import { render, staticRenderFns } from "./spinningwheel.vue?vue&type=template&id=78fb99d2&scoped=true&"
import script from "./spinningwheel.vue?vue&type=script&lang=js&"
export * from "./spinningwheel.vue?vue&type=script&lang=js&"
import style0 from "./spinningwheel.vue?vue&type=style&index=0&id=78fb99d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fb99d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78fb99d2')) {
      api.createRecord('78fb99d2', component.options)
    } else {
      api.reload('78fb99d2', component.options)
    }
    module.hot.accept("./spinningwheel.vue?vue&type=template&id=78fb99d2&scoped=true&", function () {
      api.rerender('78fb99d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/spinningwheel.vue"
export default component.exports